var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotivosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 34.1666H26.8332V28.875C26.8332 26.9305 26.1734 25.2569 24.854 23.8541C23.5346 22.4514 21.9165 21.75 19.9998 21.75C18.0832 21.75 16.4651 22.4514 15.1457 23.8541C13.8262 25.2569 13.1665 26.9305 13.1665 28.875V34.1666ZM6.6665 36.6666V34.1666H10.6665V28.875C10.6665 26.9305 11.1734 25.1458 12.1873 23.5208C13.2012 21.8958 14.6109 20.7222 16.4165 20C14.6109 19.2778 13.2012 18.0972 12.1873 16.4583C11.1734 14.8194 10.6665 13.0278 10.6665 11.0833V5.83331H6.6665V3.33331H33.3332V5.83331H29.3332V11.0833C29.3332 13.0278 28.8193 14.8194 27.7915 16.4583C26.7637 18.0972 25.3609 19.2778 23.5832 20C25.3887 20.7222 26.7984 21.8958 27.8123 23.5208C28.8262 25.1458 29.3332 26.9305 29.3332 28.875V34.1666H33.3332V36.6666H6.6665Z",
    fill: "#337066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivosIcon);
export default __webpack_public_path__ + "static/media/motivos_icon.44371a322053d353ec5fc290ca64b429.svg";
export { ForwardRef as ReactComponent };